import React from 'react';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      role: 'Working Mother',
      location: 'Austin, TX',
      rating: 5,
      text: 'Virtual Primary Care has been a game-changer for our family. When my daughter had a fever at 2 AM, I was able to connect with a doctor within hours. The peace of mind is invaluable.',
      avatar: 'https://public.readdy.ai/ai/img_res/5f0bef48e4d7488901e38e3a132683bd.jpg'
    },
    {
      name: 'Michael Chen',
      role: 'Small Business Owner',
      location: 'San Francisco, CA',
      rating: 5,
      text: 'As someone who travels frequently, having access to my primary care physician anywhere is incredible. The prescription management feature saved me during a business trip to New York.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20smiling%20Asian%20man%20in%20his%2040s%20wearing%20business%20shirt%2C%20confident%20and%20approachable%20expression%2C%20clean%20white%20background%2C%20high-quality%20portrait%20photography&width=100&height=100&seq=testimonial-michael&orientation=squarish'
    },
    {
      name: 'Emily Rodriguez',
      role: 'College Student',
      location: 'Boston, MA',
      rating: 5,
      text: 'The student discount made this affordable, and the 24-hour guarantee means I never have to miss class for a doctor\'s appointment. The doctors are incredibly knowledgeable and caring.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20smiling%20young%20Hispanic%20woman%20with%20long%20dark%20hair%2C%20wearing%20casual%20sweater%2C%20bright%20and%20cheerful%20expression%2C%20clean%20white%20background%2C%20high-quality%20portrait%20photography&width=100&height=100&seq=testimonial-emily&orientation=squarish'
    },
    {
      name: 'Robert Thompson',
      role: 'Retiree',
      location: 'Phoenix, AZ',
      rating: 5,
      text: 'Managing my diabetes has never been easier. The wellness monitoring and regular check-ins help me stay on top of my health. The doctors really take time to listen and explain everything.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20smiling%20elderly%20man%20with%20gray%20hair%20wearing%20button-up%20shirt%2C%20kind%20and%20wise%20expression%2C%20clean%20white%20background%2C%20high-quality%20portrait%20photography&width=100&height=100&seq=testimonial-robert&orientation=squarish'
    },
    {
      name: 'Jessica Park',
      role: 'Marketing Manager',
      location: 'Seattle, WA',
      rating: 5,
      text: 'The convenience is unmatched. I can have a consultation during my lunch break without leaving the office. The doctors are professional and the platform is so easy to use.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20smiling%20Korean-American%20woman%20in%20her%2030s%20wearing%20professional%20blazer%2C%20confident%20and%20friendly%20expression%2C%20clean%20white%20background%2C%20high-quality%20portrait%20photography&width=100&height=100&seq=testimonial-jessica&orientation=squarish'
    },
    {
      name: 'David Williams',
      role: 'Construction Worker',
      location: 'Denver, CO',
      rating: 5,
      text: 'Working long hours made it impossible to see a doctor during regular hours. Now I can get the care I need when it works for my schedule. The doctors understand my work demands.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20smiling%20middle-aged%20man%20wearing%20casual%20shirt%2C%20rugged%20and%20friendly%20appearance%2C%20clean%20white%20background%2C%20high-quality%20portrait%20photography&width=100&height=100&seq=testimonial-david&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Patients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real stories from real patients who have transformed their healthcare experience with Virtual Primary Care.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>

              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <blockquote className="text-gray-700 leading-relaxed">
                "{testimonial.text}"
              </blockquote>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg inline-block">
            <div className="grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600 mb-2">4.9/5</div>
                <div className="text-sm text-gray-600">Average Rating</div>
                <div className="flex justify-center mt-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600 mb-2">10K+</div>
                <div className="text-sm text-gray-600">Happy Patients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600 mb-2">98%</div>
                <div className="text-sm text-gray-600">Satisfaction Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;